import { useEffect, useState } from "react";

export function usePwaInstall() {
  const [evt, setEvt] = useState(null);
  useEffect(() => {
    const h = (e) => {
      e.preventDefault();
      setEvt(e);
    };
    window.addEventListener("beforeinstallprompt", h);
    return () => {
      window.removeEventListener("beforeinstallprompt", h);
    };
  }, []);
  const install = async () => {
    if (!evt) return;
    evt.prompt();
    await evt.userChoice;
    setEvt(null);
  };
  return { canInstall: !!evt, install };
}
